"use client";

import type * as React from "react";
import { cn } from "@/lib/utils";

type FilterPillProps = {
  label: React.ReactNode;
  selected?: boolean;
  onClick?: () => void;
  icon?: React.ReactNode;
  iconClassName?: string;
  className?: string;
};

export function FilterPill({
  label,
  selected = false,
  onClick,
  icon,
  iconClassName,
  className,
}: FilterPillProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={selected}
      className={cn(
        "inline-flex cursor-pointer items-center gap-2 rounded-lg border px-3 py-2 text-sm font-medium transition-colors",
        selected
          ? "border-gray-900 bg-gray-900 text-white"
          : "border-transparent bg-gray-100 text-gray-900 hover:bg-gray-200",
        className
      )}
    >
      {icon}
      {iconClassName ? (
        <i className={cn(iconClassName, "text-base")} aria-hidden="true" />
      ) : null}
      {label}
    </button>
  );
}

type FilterPillGroupProps = {
  children: React.ReactNode;
  className?: string;
};

export function FilterPillGroup({ children, className }: FilterPillGroupProps) {
  return (
    <div className={cn("flex flex-wrap gap-2", className)}>{children}</div>
  );
}

type FilterSectionProps = {
  title: string;
  children: React.ReactNode;
};

export function FilterSection({ title, children }: FilterSectionProps) {
  return (
    <section className="space-y-3">
      <h3 className="text-base font-bold text-gray-900">{title}</h3>
      {children}
    </section>
  );
}
